function inPagination() {
	const main = document.querySelector('.page');
	const nav = main.querySelector('.block-in-page-naviagation');
	const navigationMenu = nav.querySelector('.nav-list > ul');
	const swipeNavigation = document.querySelector('.swipe-navigation');
	if (!document.querySelector('.nav-list ul .list-item')) {
		generateLinks();
	}
	navigationMenu.addEventListener('click', (e) => {
		if (e.target.classList.contains('inpage-nav__link')) {
			navLinkClick(e);
		}
	});

	if (navigationMenu.children.length === 0) {
		nav.style.display = 'none';
	}

	if (swipeNavigation && window.innerWidth < 991) {
		const listItems = navigationMenu.querySelectorAll('li');
		let currentIndex = 0;
		const totalItems = listItems.length;

		function updateActiveItem() {
			if (totalItems > 0) {
				listItems.forEach((item) => item.classList.remove('active'));

				listItems[currentIndex].classList.add('active');

				listItems[currentIndex].scrollIntoView({
					behavior: 'smooth',
					block: 'nearest',
					inline: 'center',
				});
			}
		}

		const nextButton = document.querySelector('.swiper-button-next');
		if (nextButton) {
			nextButton.addEventListener('click', () => {
				currentIndex = (currentIndex + 1) % totalItems;
				updateActiveItem();
			});
		}

		const prevButton = document.querySelector('.swiper-button-prev');
		if (prevButton) {
			prevButton.addEventListener('click', () => {
				currentIndex = (currentIndex - 1 + totalItems) % totalItems;
				updateActiveItem();
			});
		}

		if (totalItems > 0) {
			updateActiveItem();
		}
	}
}

function generateLinks() {
	const main = document.querySelector('.page');
	const nav = main.querySelector('.block-in-page-naviagation');
	const navigationMenu = nav.querySelector('.nav-list > ul');
	const sections = main.querySelectorAll('section');

	sections.forEach((el) => {
		const id = el.id;

		if (id) {
			if (id !== 'inPageNavigation') {
				const link = id.replace(/ /g, '-');
				const titleElement = el.querySelector('h2');
				const title = titleElement
					? titleElement.textContent
					: id.replace(/-/g, ' ');
				const element = document.createElement('li');
				element.className = 'inpage-nav__list-item list-item';
				element.innerHTML = `<a class="inpage-nav__link" role="button" href="#${link}">${title}</a>`;
				navigationMenu.appendChild(element);
			}
		}
	});

	const header = document.querySelector('.main-header');
	const adminBar = document.getElementById('wpadminbar');
	const blockInPageNavigation = document.getElementById('inPageNavigation');

	if (blockInPageNavigation) {
		const headerHeight = header ? header.offsetHeight : 0;
		const adminBarHeight = adminBar
			? document.querySelector('#wpadminbar').offsetHeight
			: 0;

		const naviagationWrapper = document.querySelector(
			'#inPageNavigation .block-in-page-naviagation__wrapper'
		);
		const pageNavigationContainer = document.querySelector(
			'#inPageNavigation .block-in-page-naviagation__wrapper .page-navigation-container'
		);

		const naviagationWrapperStyles =
			window.getComputedStyle(naviagationWrapper);
		const paddingTop = parseInt(naviagationWrapperStyles.paddingTop);
		const paddingBottom = parseInt(naviagationWrapperStyles.paddingBottom);
		const totalPadding = paddingTop + paddingBottom;
		const pageNavigationContainerHeight = parseFloat(
			getComputedStyle(pageNavigationContainer).height
		);
		const blockInPageNavigationHeight =
			pageNavigationContainerHeight + totalPadding;
		document.body.style.setProperty(
			'--header-with-inpage-height',
			`${headerHeight + adminBarHeight + blockInPageNavigationHeight}px`
		);
	}
}

function navLinkClick(e) {
	const navLinks = document.querySelectorAll('.inpage-nav__link');
	navLinks.forEach((link) => link.classList.remove('active'));
	e.target.classList.add('active');
}

const controller = {
	init() {
		inPagination();
	},
	resized() {
		inPagination();
	},
	loaded() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};

export default controller;
